import styled from 'styled-components';
import { H1, H2, H3, SectionParent } from '../../StyledComponents';

import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import assets from '../../../assets/v2/Partner/assets.svg';
import DeliveryApplication from '../../../assets/v2/Partner/DeliveryApplication.svg';
import DigitalSignage from '../../../assets/v2/Partner/DigitalSignage.svg';
import FoodDelivery from '../../../assets/v2/Partner/FoodDelivery.svg';
import Hospitality from '../../../assets/v2/Partner/Hospitality.svg';
import PatientMonitoring from '../../../assets/v2/Partner/PatientMonitoring.svg';
import POS from '../../../assets/v2/Partner/POS.svg';
import TeleMedicine from '../../../assets/v2/Partner/TeleMedicine.svg';

import { navigate } from '@reach/router';
require('./pricing.scss');

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #fff;
  padding: 96px 0 !important;
  background-size: contain;
  @media (max-width: 768px) {
    // padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    // padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  margin-top: 2rem;
  border-radius: 4px;
  width: 100%;
  margin: 1rem 0;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
}
  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    /* grid-template-columns: repeat(2, 1fr); */
    padding: 2rem;
    width: 100%;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2.5rem;
    // padding-right: 2rem;
  }
  @media (min-width: 768px) {
    padding-top: 1.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 3;
  border-radius: 5px;
  //   width: 200px;
  @media (max-width: 1100px) {
    max-width: 100%;
    margin-bottom: 2rem;
    grid-column: span 1;
  }
`;

const BottomWrapper = styled.div`
  display: grid;
  grid-column: span 12;
  grid-template-columns: repeat(12, 1fr);
  width: 80%;
  justify-self: center;
  justify-items: center;
  @media (max-width: 1024px) {
    grid-column: span 4;
    width: 80%;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    width: 100%;
    grid-column: span 2;
    grid-template-columns: repeat(2, 1fr);
  }
`;
const GridItemBottom = styled.div`
  grid-column: span 4;
  justify-self: center;
  border-radius: 5px;
  max-width: 100%;
  margin-top: 2rem;
  @media (max-width: 1024px) {
    grid-column: span 1;
    margin-top: 0;
    // justify-self: start !important;
    padding-left: 0 !important;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    justify-self: center !important;
    margin-bottom: 2rem;
  }
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center !important;
  color: #9095ab;
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 768px) {
    justify-items: center;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  @media (max-width: 768px) {
    // margin-left: -1rem;
  }
  @media (max-width: 350px) {
    margin-left: 0;
  }
`;

const HeroTitle = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.61;
  letter-spacing: normal;
  color: #151828;
`;

const HeroSubTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.75;
  letter-spacing: normal;
  color: #4f5263;
  text-align: center;
  padding: 2rem;

  //   width: 50%;
  //   @media (max-width: 768px) {
  //     width: 100%;
  //   }
`;
const HeroSubTitleText = styled.div`
  font-size: 18px;
  padding: 2rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  text-align: center;
  //   width: 50%;
  //   @media (max-width: 768px) {
  //     width: 100%;
  //   }
`;
const StyledImg = styled(LazyLoadImage)`
  height: 46px;
  @media (max-width: 768px) {
    height: 56px;
  }
`;
const StyledImgLogo = styled(LazyLoadImage)`
  height: 72px;
  @media (max-width: 520px) {
    height: 46px;
    margin: 10px;
  }
`;
const TitlesContainer = styled.div`
  @media (max-width: 768px) {
    text-align: left;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  height: 48px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
`;

const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-top: 4rem;
`;

const BottomBanner = styled.div`
  display: grid;
  border-radius: 8px;
  border: solid 1px #9095ab;
  background-color: #ffffff;
  grid-column: span 1;
  /* justify-self: end; */
  padding: 2rem;
  margin-left: 2rem;
  color: #735dbe;
  cursor: pointer;
  :hover {
    animation-name: example;
    animation-duration: 0.1s;
    box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19);
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    @keyframes example {
      /* 0% {
        background-color: #ffffff;
      } */
      100% {
        background-color: #735dbe;
      }
    }
  }
  @media (max-width: 520px) {
    grid-column: span 2;
    margin-left: 0;
    margin-bottom: 2rem;
  }
`;

const BottomBannerImage = styled.div`
  display: grid;
  justify-content: center;
  padding-bottom: 1rem;
`;

const BottomBannerText = styled.div`
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;
const SectionTitle = styled.div`
  padding: 0 0 20px;
  margin: 0 1rem;
  color: #1f2131;
  @media (max-width: 520px) {
    // text-align: center;
    width: 80%;
    // padding: 1rem 0;
    padding-bottom: 0;
  }

  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  // line-height: normal;
  letter-spacing: normal;
  text-align: left;
`;
export default class PricingSectionTwo extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      hover1: false,
      hover2: false,
    };
  }
  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <SectionTitle>
            <div style={{ display: 'grid', gridTemplateColumns: '3fr 10fr' }}>
              <div>
                <ImgWrapper>
                  <StyledImgLogo src={assets} />
                </ImgWrapper>
              </div>
              <div
                style={{
                  color: '#4f5263',
                  fontSize: '16px',
                  fontWeight: 'normal',
                }}
              >
                <p
                  style={{
                    color: '#151828',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  }}
                >
                  Android Solutions Providers | ISVs
                </p>
                ISVs in retail, education, logistics & the supply chain.
              </div>
            </div>
          </SectionTitle>
          <GridContainer style={{ maxWidth: '780px' }}>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={DigitalSignage} />
                    </ImgWrapper>
                  </TitlesContainer>

                  <GridItemContent>
                    <GridTitle>Digital Signage</GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>

            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={POS} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>POS</GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={FoodDelivery} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>Food Delivery</GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={TeleMedicine} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>
                      Tele Medicine <br /> Application
                    </GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <BottomWrapper>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={PatientMonitoring} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>Patient Monitoring</GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={DeliveryApplication} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>Delivery Application</GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={Hospitality} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>Hospitality</GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
            </BottomWrapper>
          </GridContainer>
        </SectionOne>
      </div>
    );
  }
}
